import React, { Component } from 'react';
import { Container, Row, Label, Input, Col} from 'reactstrap';
import { Link } from 'react-router-dom';

class RevenueManagementContainer extends Component {

    constructor(props) {
        super(props);

        let sel = {
            showUnset: true
        };

        this.listView = this.props.location.pathname.split('/').filter(item => item !== '').pop() === 'revenue-management' ? true : false;

        this.activeServices = ['Unset'];
        this.props.clients.forEach(client => {
            client.services.filter(service => service.active).forEach(service => {
                if (this.activeServices.findIndex(item => item === service.name) === -1) {
                    this.activeServices.push(service.name);
                    sel["show" + this.getLetters(service.name)] = true;
                }
            });
        });
        this.activeServices.sort();

        this.state = sel;
    }

    getLetters = (str) => {
        this.props.info('RevenueManagementContainer.js/getLetters (str)',str);
        return str.replace(/[^a-zA-Z]+/g, '');
    }

    onlySelect = (service) => {
        this.props.log('RevenueManagementContainer.js/onlySelect (service)',service);
        let sel = {...this.state};
        Object.keys(this.state).forEach(key => {
            sel[key] = false;
        });
        sel[service] = true;
        this.setState(sel)
    }
    
    render = () => {
        this.props.info('RevenueManagementContainer.js/render');
        return (
            <Container>
                <Row className="text-left adminRow font-weight-bold">
                    {this.activeServices.map(service => (
                        <div key={service} className="px-4 pull-left">
                            <Label><Input
                                type="checkbox"
                                name={this.getLetters("show" + service)}
                                checked={this.props.isFieldNull(this.state[this.getLetters("show" + service)], true)}
                                onChange={() => this.setState((prevState) => {
                                    let sel = prevState;
                                    sel[this.getLetters("show" + service)] = !this.state[this.getLetters("show" + service)];
                                    return sel;
                                })}
                            /> {service}</Label><span onClick={() => this.onlySelect(this.getLetters("show" + service))} className="pull-left px-2 onlySelect">Only</span>
                        </div>
                    ))}
                </Row>
                {this.props.clients.filter(client => client.active === true &&
                    (
                        (client.services.filter(service => service.active).map(service => this.getLetters("show" + service.name))
                            .findIndex(service => this.state[service]) > -1) ||
                        (this.state.showUnset &&
                            client.services.filter(service => service.active).length === 0)
                    )
                ).map(client => (
                    <Row key={client.id} className="mainRow">
                        <Col md={12} className="text-left">
                            <Link to={{ pathname: '/revenue-management/' + client.id }}>{client.client}</Link>
                        </Col>
                    </Row>
                ))}
            </Container>
        );
    }
}

export default RevenueManagementContainer;
